import { render, staticRenderFns } from "./OutstandingBranch.vue?vue&type=template&id=03cf5958"
import script from "./OutstandingBranch.vue?vue&type=script&lang=js"
export * from "./OutstandingBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports